module.exports = "/_next/static/images/street-wreath-bd06920dccd2afb828397253bd214927.svg";